import React from 'react';
import { Cpu, Shield, TrendingUp, Wallet, Layers, Users } from 'lucide-react';

const cards = [
  { icon: Cpu, title: 'AI-Powered Innovation', description: 'Leverage the power of AI to build, automate, and scale faster than ever.' },
  { icon: Shield, title: 'Scalable & Secure', description: 'Enterprise-grade security and infrastructure built to scale with your business.' },
  { icon: TrendingUp, title: 'Built for Growth', description: 'Solutions designed to increase efficiency, revenue, and customer satisfaction.' },
  { icon: Wallet, title: 'Affordable & Flexible', description: 'Flexible payment options and plans that fit businesses of all sizes.' },
  { icon: Layers, title: 'All-in-One Platform', description: "From development to deployment to support — we've got you covered." },
  { icon: Users, title: 'Real Human Support', description: "We're here when you need us. Real people. Real solutions." },
];

const WhyChoose = () => {
  return (
    <section id="about" className="relative py-20">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-[13px] font-semibold bg-gradient-to-r from-[#a855f7] to-[#60a5fa] bg-clip-text text-transparent mb-3">
            Why Choose BLKPixel?
          </div>
          <h2 className="text-white text-[36px] lg:text-[42px] font-bold tracking-tight">
            Smarter Technology. Bigger Impact.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group rounded-2xl bg-[#0d0d16]/70 border border-white/5 p-5 hover:border-[#a855f7]/40 hover:bg-[#12121d]/90 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#7c3aed]/30 to-[#4f46e5]/20 border border-[#a855f7]/30 flex items-center justify-center mb-4">
                <card.icon className="w-5 h-5 text-[#c084fc]" />
              </div>
              <div className="text-white font-semibold text-[14px] leading-tight">{card.title}</div>
              <div className="text-gray-400 text-[11.5px] mt-2 leading-relaxed">{card.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
